import React from "react";

const VRM = () => {
  return (
    <section className="relative bg-gradient-to-br from-black via-gray-900 to-black text-white px-6 py-20 overflow-hidden">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 items-center gap-16">
        {/* Left Content: Image */}
        <div className="relative">
        <div className="w-full max-w-xs md:max-w-[400px] h-[500px] md:h-[600px] rounded-3xl overflow-hidden shadow-2xl transform hover:scale-105 transition duration-500 ease-in-out mx-auto md:mx-0">
        <img
            src="/assets/images/vrm-poster.png"
            alt="Digital Marketing"
            className="w-full h-full object-cover"
          />
        </div>

        </div>

        {/* Right Content: Text */}
        <div className="flex flex-col justify-center">
          <h2 className="text-4xl md:text-5xl font-extrabold leading-tight mb-6 text-green-400">
            Discover VRM Digital
          </h2>
          <p className="text-gray-300 text-lg leading-relaxed mb-8">
            VRM Digital is your one-stop destination for dynamic digital marketing solutions. 
            We partner with businesses of all sizes to craft custom strategies that drive traffic, increase engagement, 
            and boost conversions. Whether you're a startup or a large enterprise — we've got your growth covered.
          </p>
          
          {/* Enhanced Button with Animation, Effects, and Reduced Width */}
          <div className="relative group inline-block">
            {/* Animated glow effect */}
            <div className="absolute -inset-0.5 bg-gradient-to-r from-green-500 to-emerald-400 rounded-xl blur opacity-60 group-hover:opacity-100 transition duration-500 group-hover:duration-200 animate-pulse"></div>
            
            {/* Button with hover effect and reduced width */}
            <a
              href="https://vrmdigital.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="relative flex items-center justify-center gap-2 bg-black text-green-400 hover:text-black font-bold text-lg px-6 py-3 rounded-xl transition-all duration-300 hover:bg-gradient-to-r from-green-500 to-emerald-400 shadow-xl group-hover:shadow-green-500/40"
            >
              <span>Explore More</span>
              <svg 
                className="w-5 h-5 transform transition-transform duration-300 group-hover:translate-x-1" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24" 
                xmlns="http://www.w3.org/2000/svg"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth="2" 
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </a>
          </div>
        </div>
      </div>

      {/* Decorative Gradient Blobs */}
      <div className="absolute -top-20 -left-20 w-72 h-72 bg-pink-500 rounded-full mix-blend-multiply filter blur-2xl opacity-30 animate-pulse"></div>
      <div className="absolute -bottom-20 -right-20 w-72 h-72 bg-blue-500 rounded-full mix-blend-multiply filter blur-2xl opacity-30 animate-pulse"></div>
    </section>
  );
};

export default VRM;